import React from 'react';
export function GaugeIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.342 4.81A11 11 0 104.8 21.31a2.921 2.921 0 001.92.69h10.561c.7.008 1.38-.237 1.915-.69a10.99 10.99 0 00.146-16.5zM17.888 19.8a.923.923 0 01-.607.2H6.72a.929.929 0 01-.609-.2A8.965 8.965 0 013.062 14H5a1 1 0 000-2H3.07c.012-.111.011-.221.027-.331A8.843 8.843 0 014.98 7.394l1.313 1.313a1 1 0 001.414-1.414L6.393 5.979a8.915 8.915 0 014.6-1.924H11V6a1 1 0 002 0V4.059a8.858 8.858 0 014.611 1.917l-1.318 1.317a1 1 0 101.414 1.414l1.315-1.314A9 9 0 0120.941 12H19a1 1 0 100 2h1.943a8.99 8.99 0 01-3.055 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.828 11.758l-2.318 2.318A1.991 1.991 0 1014 16a2.044 2.044 0 00-.074-.514l2.316-2.317a1 1 0 10-1.414-1.414v.002z"
  }));
}